<template>
  <div id="app">
    <AuthenticationForm>
      <div slot="form-title">
        <h5 class="text-center">Enter the verification code sent to your email</h5>
      </div>

      <div slot="form">
        <b-form @submit.prevent inline>
          <div class="col-md-12 text-center mb-3 mt-3">
            <b-alert
              v-model="showDismissibleAlert"
              variant="danger"
              dismissible
            >Token is Expire or Do not Match</b-alert>
            <b-form-input type="text" maxlength="6" v-model="token" placeholder="6-digit code"></b-form-input>
            <br />
            <span class="text-danger float-right" v-if="errors.token">{{ errors.token}}</span>
          </div>

          <div class="col-md-12 text-center">
            <b-button type="submit" variant="amej-button" @click="AccountActivation">Confirm</b-button>
          </div>
        </b-form>
      </div>

      <!--     <div slot="form-footer">
      <div class="row">
          <span><strong><a href="/">Already a member?</a></strong></span>
      </div>
      </div>-->
    </AuthenticationForm>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import AuthenticationForm from "../login_components/AuthenticationForm";

// const axios = require('axios');
export default {
  name: "RegisterConfirmation",
  components: {
    AuthenticationForm: AuthenticationForm,
  },
  computed: {
    ...mapState(["errormessage", "accountsuccessmessage"]),
  },
  data() {
    return {
      username: "",
      password: "",
      text: "Login Form",
      errors: [],
      disabledLogin: true,
      token: "",
      showDismissibleAlert: false,
    };
  },

  methods: {
    ...mapMutations(["setToken"]),

    AccountActivation() {
      this.errors = [];
      if (this.token == "") {
        this.errors["token"] = "Token required.";
      } else {
        this.$store
          .dispatch("activateaccount", {
            token: this.token,
          })
          .then(() => {
            if (this.successmessage == "success") {
              this.$router.replace("/");
              // alert("Account Activate Successfully");
            } else if (this.errormessage == "errormessage") {
              this.showDismissibleAlert = true;
              this.$router.replace("/activateaccount");
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
